import React from "react";

import SectionSidePanel from "components/Panel/SectionSidePanel";
import InfoDoubleCard from "components/Chart/InfoDoubleCard";

function PanelCharts({ occRate, checkData, occRoom }) {
  if (!occRate.title) return;

  return (
    <div id="panel-charts" className="flex gap-x-4 px-3 py-3">
      <InfoDoubleCard
        key="occ_rate"
        title={occRate.title}
        elements={occRate.elements}
        color="border-orange-400"
      />
      <InfoDoubleCard
        key="occ_room"
        title={occRoom.title}
        elements={occRoom.elements}
        color="border-cyan-600"
      />
      <SectionSidePanel key="checks" data={checkData} />
    </div>
  );
}

export default PanelCharts;
